const API_URL = process.env.REACT_APP_API_URL;

if (!API_URL) {
  throw new Error('REACT_APP_API_URL is undefined. Set it in frontend/.env before starting the app.');
}

export { API_URL };
